module.exports = __webpack_public_path__ + "img/prevideomockup.ee4c9a51.png";